import React, { Component } from 'react';

import Header from './Header/Header';
import { Redirect } from 'react-router';

class Default extends Component {
  render = () => {
    return (
      <React.Fragment>
        {this.props.isLogged === false && <Redirect to="/" />}
        <Header {...this.props} />
        <div style={{backgroundColor: '#B5BCC1', paddingBottom: '5rem', minHeight: '50vw', paddingTop: '110px'}}>
          {this.props.children}
        </div>
      </React.Fragment>
    );
  };
}

export default Default;
